import { useContext } from "react";
import { AutoMapperContext } from "./AutoMapperProvider.js";
function useAutoMapper() {
  const context = useContext(AutoMapperContext);
  return context.mapper;
}
export {
  useAutoMapper
};
//# sourceMappingURL=hooks.js.map
